import React, { useEffect, useState } from 'react'
import EditMeetingModal from './components/EditMeetingModal'
import AddMemberModal from './components/AddMemberModal'

// Lightweight React-driven prompt/confirm bridge using window events.
// Components call `await window.reactPrompt(message, default)` or `await window.reactConfirm(message)`.
if (typeof window !== 'undefined' && !window.reactPrompt) {
  window.__reactModalPromises = {}
  window.reactPrompt = function(message, defaultValue) {
    return new Promise((resolve) => {
      const id = Math.random().toString(36).slice(2)
      window.__reactModalPromises[id] = resolve
      const ev = new CustomEvent('react-modal-request', { detail: { id, type: 'prompt', message, defaultValue } })
      window.dispatchEvent(ev)
    })
  }
  window.reactConfirm = function(message) {
    return new Promise((resolve) => {
      const id = Math.random().toString(36).slice(2)
      window.__reactModalPromises[id] = resolve
      const ev = new CustomEvent('react-modal-request', { detail: { id, type: 'confirm', message } })
      window.dispatchEvent(ev)
    })
  }
}

function SubmitReport() {
  const [clubs, setClubs] = useState([])
  const [membersList, setMembersList] = useState([])
  const [rolesList, setRolesList] = useState([])
  // club creation is managed in Admin tab now

  const [form, setForm] = useState({
    meeting_no: '', theme: '', venue: '', meeting_date: '', club_name: '', mom_text: ''
  })

  const [rows, setRows] = useState([])
  const [guests, setGuests] = useState([])

  useEffect(() => { fetch('/api/clubs').then(r=>r.json()).then(setClubs) }, [])
  useEffect(() => { fetch('/api/members').then(r=>r.json()).then(setMembersList) }, [])
  useEffect(() => { fetch('/api/admin/roles').then(r=>r.json()).then(setRolesList) }, [])

  function addMemberRow(){ setRows(r=>[...r, {member_id:'', role:'Attendance Only'}]) }
  function removeMemberRow(i){ setRows(r=>r.filter((_,idx)=>idx!==i)) }
  function updateMember(i, field, val){ setRows(r=>r.map((row,idx)=> idx===i ? {...row, [field]: val} : row)) }

  function addGuest(){ setGuests(g=>[...g, {name:'', role:'Guest'}]) }
  function updateGuest(i, field, val){ setGuests(g=>g.map((row,idx)=> idx===i ? {...row, [field]: val} : row)) }
  function removeGuest(i){ setGuests(g=>g.filter((_,idx)=>idx!==i)) }

  // Club management moved to Admin tab

  async function submit(){
    const payload = {
      ...form,
      members: rows.map(r=>({ member_id: r.member_id || null, role: r.role })),
      guests: guests.filter(g=>g.name).map(g=>({ name: g.name, role: g.role }))
    }
    const res = await fetch('/api/meetings', {method:'POST', headers:{'Content-Type':'application/json'}, body: JSON.stringify(payload)})
    if(res.ok){ alert('Saved'); setRows([]); setGuests([]); setForm({meeting_no:'',theme:'',venue:'',meeting_date:'',club_name:'',mom_text:''}) }
    else { const txt = await res.text(); alert('Error: '+txt) }
  }

  return (
    <div>
      <div className="header-grid">
        <div className="field"><label className="small">Meeting No</label><input value={form.meeting_no} onChange={e=>setForm({...form, meeting_no: e.target.value})} /></div>
        <div className="field"><label className="small">Theme</label><input value={form.theme} onChange={e=>setForm({...form, theme: e.target.value})} /></div>
        <div className="field"><label className="small">Venue</label><input value={form.venue} onChange={e=>setForm({...form, venue: e.target.value})} /></div>
        <div className="field"><label className="small">Meeting Date</label><input type="date" value={form.meeting_date} onChange={e=>setForm({...form, meeting_date: e.target.value})} /></div>
      </div>

      <div style={{display:'flex', gap:8, alignItems:'flex-end', marginBottom:12}}>
        <div style={{flex:1}}>
          <label className="small">Club Name</label>
          <div style={{display:'flex', gap:8}}>
            <select style={{flex:1}} value={form.club_name} onChange={e=>setForm({...form, club_name: e.target.value})}>
              <option value="">-- select club --</option>
              {clubs.map(c => <option key={c.id} value={c.name}>{c.name}</option>)}
            </select>
          </div>
          {/* Club creation is handled in Admin tab */}
        </div>
      </div>

      <div className="container">
        <h3>Members</h3>
        <div className="list">
          {rows.map((r, i) => (
            <div key={i} className="table-row">
              <select value={r.member_id} onChange={e=>updateMember(i,'member_id', e.target.value)} style={{flex:2}}>
                <option value="">-- select member --</option>
                {membersList.map(m => <option key={m.id} value={m.id}>{m.name}</option>)}
              </select>
              <select value={r.role} onChange={e=>updateMember(i,'role', e.target.value)} style={{flex:2}}>
                {rolesList.map(role => <option key={role.id} value={role.name}>{role.name}</option>)}
              </select>
              <div className="points-badge">{(rolesList.find(x=>x.name===r.role)||{points:1}).points}</div>
              <button className="secondary" onClick={()=>removeMemberRow(i)}>Remove</button>
            </div>
          ))}
          <div style={{marginTop:8}}><button className="primary" onClick={addMemberRow}>+ Add Member</button></div>
        </div>

        <h3 style={{marginTop:18}}>Guests</h3>
        <div className="list">
          {guests.map((g, i) => (
            <div key={i} className="table-row">
              <input placeholder="Guest name" value={g.name} onChange={e=>updateGuest(i,'name', e.target.value)} style={{flex:2}} />
              <input placeholder="Role / details" value={g.role} onChange={e=>updateGuest(i,'role', e.target.value)} style={{flex:2}} />
              {/* Guests do not receive points by default */}
              <button className="secondary" onClick={()=>removeGuest(i)}>Remove</button>
            </div>
          ))}
          <div style={{marginTop:8}}><button className="primary" onClick={addGuest}>+ Add Guest</button></div>
        </div>

        <div style={{marginTop:18, display:'flex', justifyContent:'space-between', alignItems:'center'}}>
          <textarea placeholder="Minutes / MoM" value={form.mom_text} onChange={e=>setForm({...form, mom_text: e.target.value})} style={{flex:1, marginRight:12, minHeight:80}} />
          <div style={{width:220}}>
            <button className="primary" style={{width:'100%'}} onClick={submit}>Submit Report</button>
          </div>
        </div>
      </div>
    </div>
  )
}

function PastReports({ onEdit, refreshKey }){
  const [data, setData] = useState([])
  const [members, setMembers] = useState([])

  useEffect(()=>{
    Promise.all([fetch('/api/meetings/archive'), fetch('/api/members')])
      .then(async ([reportsResponse, membersResponse])=>{
        setData(await reportsResponse.json())
        setMembers(await membersResponse.json())
      })
  }, [refreshKey])

  const membersById = Object.fromEntries(members.map(member=>[String(member.id), member.name]))

  function attendeeName(entry){
    return entry.attendee_type === 'Member'
      ? (membersById[String(entry.member_id)] || `Member ${entry.member_id || ''}`)
      : (entry.name_override || 'Guest')
  }

  function pdfLine(text){
    return String(text || '').normalize('NFKD').replace(/[^\x20-\x7E]/g, '').replace(/\\/g, '\\\\').replace(/[()]/g, '\\$&')
  }

  function wrapPdfText(text, maxLength = 84){
    const words = String(text || '').replace(/\s+/g, ' ').trim().split(' ')
    const lines = []
    let line = ''
    words.forEach(word=>{
      if((line + ' ' + word).trim().length > maxLength && line){ lines.push(line); line = word }
      else line = (line + ' ' + word).trim()
    })
    if(line) lines.push(line)
    return lines.length ? lines : ['']
  }

  function downloadPdf(meeting){
    const lines = [
      'SECRETARY REPORT',
      `Meeting: ${meeting.meeting_no || 'Not specified'}`,
      `Date: ${meeting.meeting_date || 'Not specified'}`,
      `Club: ${meeting.club_name || 'Not specified'}`,
      `Theme: ${meeting.theme || 'Not specified'}`,
      `Venue: ${meeting.venue || 'Not specified'}`,
      '', 'ATTENDEES'
    ]
    const attendeesByRole = (meeting.ledger || []).reduce((groups, attendee)=>{
      const role = attendee.attendee_type === 'Member' ? (attendee.role || 'Attendance') : 'Guests'
      ;(groups[role] ||= []).push(attendee)
      return groups
    }, {})
    Object.entries(attendeesByRole).forEach(([role, attendees])=>{
      lines.push('', `${role.toUpperCase()} (${attendees.length})`)
      attendees.forEach(entry=>{
        const details = entry.attendee_type === 'Member'
          ? `${attendeeName(entry)} - ${entry.points_awarded || 0} points`
          : attendeeName(entry)
        lines.push(...wrapPdfText(details))
      })
    })
    lines.push('', 'MINUTES')
    lines.push(...wrapPdfText(meeting.mom_text || 'No minutes recorded.'))

    const pageLines = []
    for(let index = 0; index < lines.length; index += 45) pageLines.push(lines.slice(index, index + 45))
    const objects = []
    objects[1] = '<< /Type /Catalog /Pages 2 0 R >>'
    objects[3] = '<< /Type /Font /Subtype /Type1 /BaseFont /Helvetica >>'
    const pageIds = []
    pageLines.forEach((page, index)=>{
      const pageId = 4 + index * 2
      const contentId = pageId + 1
      pageIds.push(`${pageId} 0 R`)
      const content = `BT\n/F1 11 Tf\n50 790 Td\n15 TL\n${page.map(line=>`(${pdfLine(line)}) Tj\nT*`).join('\n')}\nET`
      objects[pageId] = `<< /Type /Page /Parent 2 0 R /MediaBox [0 0 612 792] /Resources << /Font << /F1 3 0 R >> >> /Contents ${contentId} 0 R >>`
      objects[contentId] = `<< /Length ${content.length} >>\nstream\n${content}\nendstream`
    })
    objects[2] = `<< /Type /Pages /Kids [${pageIds.join(' ')}] /Count ${pageIds.length} >>`
    const encoder = new TextEncoder()
    let pdf = '%PDF-1.4\n'
    const offsets = [0]
    for(let index = 1; index < objects.length; index++){
      offsets[index] = encoder.encode(pdf).length
      pdf += `${index} 0 obj\n${objects[index]}\nendobj\n`
    }
    const xrefOffset = encoder.encode(pdf).length
    pdf += `xref\n0 ${objects.length}\n0000000000 65535 f \n`
    for(let index = 1; index < objects.length; index++) pdf += `${String(offsets[index]).padStart(10, '0')} 00000 n \n`
    pdf += `trailer\n<< /Size ${objects.length} /Root 1 0 R >>\nstartxref\n${xrefOffset}\n%%EOF`
    const url = URL.createObjectURL(new Blob([pdf], {type:'application/pdf'}))
    const link = document.createElement('a')
    link.href = url
    link.download = `secretary-report-${String(meeting.meeting_no || meeting.id).replace(/[^a-z0-9_-]/gi, '-')}.pdf`
    link.click()
    URL.revokeObjectURL(url)
  }

  return (
    <section className="past-reports">
      <div className="reports-hero"><div><span className="eyebrow">Meeting archive</span><h2>Past reports</h2><p>Review meeting details, attendees, and minutes in one place.</p></div><span>{data.length} saved {data.length === 1 ? 'report' : 'reports'}</span></div>
      <div className="report-list">{data.map(m=> (
        <article key={m.id} className="report-card">
          <div className="report-card-header"><div><span className="report-date">{m.meeting_date || 'No date'}</span><h3>Meeting {m.meeting_no || 'Untitled'}</h3><p>{m.theme || 'No theme recorded'}</p></div><div className="report-actions"><button className="secondary" onClick={()=>onEdit && onEdit(m)}>Edit report</button><button className="primary" onClick={()=>downloadPdf(m)}>Download PDF</button></div></div>
          <div className="report-meta"><span><b>Club</b>{m.club_name || 'Not specified'}</span><span><b>Venue</b>{m.venue || 'Not specified'}</span><span><b>Attendees</b>{(m.ledger || []).length}</span></div>
          <div className="report-body"><div><h4>Attendees</h4>{Object.entries((m.ledger || []).reduce((groups, attendee)=>{ const role = attendee.attendee_type === 'Member' ? (attendee.role || 'Attendance') : 'Guests'; (groups[role] ||= []).push(attendee); return groups }, {})).map(([role, attendees])=><div className="role-attendee-group" key={role}><span className="role-group-label">{role}<small>{attendees.length}</small></span><div className="attendee-chips">{attendees.map(l=><span className={l.attendee_type === 'Member' ? 'attendee-chip member-chip' : 'attendee-chip guest-chip'} key={l.id}>{attendeeName(l)}{l.attendee_type === 'Member' && <small>{l.points_awarded || 0} pts</small>}</span>)}</div></div>)}{!(m.ledger || []).length && <span className="empty-copy">No attendees recorded.</span>}</div><div className="minutes-preview"><h4>Minutes</h4><p>{m.mom_text || 'No minutes recorded for this meeting.'}</p></div></div>
        </article>
      ))}{!data.length && <div className="leaderboard-empty">No reports have been saved yet.</div>}</div>
    </section>
  )
}

function Leaderboards(){
  const [active, setActive] = useState('monthly') // 'monthly' or 'term'
  const [month, setMonth] = useState('')
  const [monthlyData, setMonthlyData] = useState([])

  // term state
  const [termSub, setTermSub] = useState('janjun') // 'janjun' or 'juldec'
  const [year, setYear] = useState(new Date().getFullYear())
  const [termData, setTermData] = useState([])

  useEffect(()=>{
    // fetch monthly standings from backend which supports ?month=YYYY-MM
    const q = month ? '?month='+month : ''
    fetch('/api/standings/month'+q).then(r=>r.json()).then(d=>{ setMonthlyData(d || []) })
  }, [month])

  useEffect(()=>{
    // prefer server-side term endpoint if available
    async function load(){
      try{
        const res = await fetch('/api/standings/term?year='+year+'&half='+termSub)
        if(res.ok){
          const list = await res.json()
          setTermData(list)
          return
        }
      }catch(e){/* fallback to client compute */}
      const res = await fetch('/api/meetings/archive')
      const meetings = await res.json()
      // aggregate points per member id for the selected year and month range
      const months = termSub === 'janjun' ? [1,2,3,4,5,6] : [7,8,9,10,11,12]
      const sums = {}
      meetings.forEach(m => {
        if(!m.meeting_date) return
        const d = new Date(m.meeting_date)
        if(d.getFullYear() !== Number(year)) return
        const mo = d.getMonth()+1
        if(!months.includes(mo)) return
        ;(m.ledger||[]).forEach(l=>{
          if(l.attendee_type !== 'Member') return
          const id = l.member_id
          const pts = Number(l.points_awarded||0)
          if(!id) return
          sums[id] = (sums[id]||0) + pts
        })
      })
      // resolve member names
      const members = await (await fetch('/api/members')).json()
      const byId = Object.fromEntries(members.map(x=>[x.id, x.name]))
      const list = Object.keys(sums).map(id=>({ member_id: id, member_name: byId[id]||('Member '+id), total: sums[id] }))
      list.sort((a,b)=>b.total - a.total)
      setTermData(list)
    }
    load()
  }, [termSub, year])

  // generate last 12 months options
  function last12Months(){
    const opts = []
    const now = new Date()
    for(let i=0;i<12;i++){
      const d = new Date(now.getFullYear(), now.getMonth()-i, 1)
      const mm = (d.getMonth()+1).toString().padStart(2,'0')
      opts.push({value: `${d.getFullYear()}-${mm}`, label: `${d.toLocaleString('default',{month:'long'})} ${d.getFullYear()}`})
    }
    return opts
  }

  function yearsOptions(){
    const y = new Date().getFullYear()
    return [y, y-1, y-2]
  }

  const standings = active === 'monthly' ? monthlyData : termData
  const periodLabel = active === 'monthly'
    ? (month ? last12Months().find(item => item.value === month)?.label : 'Current month')
    : `${termSub === 'janjun' ? 'January – June' : 'July – December'} ${year}`
  const medal = ['🥇', '🥈', '🥉']

  return (
    <section className="leaderboard">
      <div className="leaderboard-hero">
        <div>
          <span className="eyebrow">Club recognition</span>
          <h2>Leaderboards</h2>
          <p>Celebrating the members who keep every meeting moving.</p>
        </div>
        <div className="leaderboard-tabs">
          <button className={active==='monthly' ? 'leaderboard-tab active' : 'leaderboard-tab'} onClick={()=>setActive('monthly')}>Monthly</button>
          <button className={active==='term' ? 'leaderboard-tab active' : 'leaderboard-tab'} onClick={()=>setActive('term')}>Term</button>
        </div>
      </div>

      <div className="leaderboard-controls">
        {active === 'monthly' ? (
          <label>Period
            <select value={month} onChange={e=>setMonth(e.target.value)}>
              <option value="">Current month</option>
              {last12Months().map(m=> <option key={m.value} value={m.value}>{m.label}</option>)}
            </select>
          </label>
        ) : <>
          <label>Year
            <select value={year} onChange={e=>setYear(Number(e.target.value))}>
              {yearsOptions().map(y=> <option key={y} value={y}>{y}</option>)}
            </select>
          </label>
          <div className="segment-control">
            <button className={termSub==='janjun' ? 'active' : ''} onClick={()=>setTermSub('janjun')}>Jan–Jun</button>
            <button className={termSub==='juldec' ? 'active' : ''} onClick={()=>setTermSub('juldec')}>Jul–Dec</button>
          </div>
        </>}
        <span className="period-label">{periodLabel}</span>
      </div>

      {standings.length ? <>
        <div className="podium">
          {standings.slice(0, 3).map((member, index) => (
            <article className={`podium-card place-${index + 1}`} key={member.member_id}>
              <span className="medal">{medal[index]}</span>
              <div className="avatar">{(member.member_name || '?')[0].toUpperCase()}</div>
              <strong>{member.member_name}</strong>
              <span>{member.total} points</span>
            </article>
          ))}
        </div>
        <div className="ranking-card">
          <div className="ranking-heading"><span>Rank</span><span>Member</span><span>Points</span></div>
          {standings.slice(0, 20).map((member, index) => (
            <div className="ranking-row" key={member.member_id}>
              <span className="rank-number">{index + 1}</span>
              <span className="member-name"><span className="mini-avatar">{(member.member_name || '?')[0].toUpperCase()}</span>{member.member_name}</span>
              <strong>{member.total}<small> pts</small></strong>
            </div>
          ))}
        </div>
      </> : <div className="leaderboard-empty">No points have been recorded for this period yet.</div>}
    </section>
  )
}

function Admin({isSuperAdmin}){
  const [clubs, setClubs] = useState([])
  const [members, setMembers] = useState([])
  const [roles, setRoles] = useState([])
  const [reports, setReports] = useState([])
  const [users, setUsers] = useState([])
  const [showAddMember, setShowAddMember] = useState(false)

  useEffect(()=>{ fetch('/api/clubs').then(r=>r.json()).then(setClubs) }, [])
  useEffect(()=>{ fetch('/api/members').then(r=>r.json()).then(setMembers) }, [])
  useEffect(()=>{ fetch('/api/admin/roles').then(r=>r.json()).then(setRoles) }, [])
  useEffect(()=>{ fetch('/api/meetings/archive').then(r=>r.json()).then(setReports) }, [])
  useEffect(()=>{ if(isSuperAdmin) fetch('/api/admin/users').then(r=>r.json()).then(setUsers) }, [isSuperAdmin])

  async function addAllowedUser(){
    const email = await window.reactPrompt('Approved email address:')
    if(!email) return
    const password = await window.reactPrompt('Temporary password (minimum 8 characters):')
    if(!password) return
    const role = await window.reactPrompt('Role: admin or super_admin', 'admin')
    const res = await fetch('/api/admin/users', {method:'POST', headers:{'Content-Type':'application/json'}, body: JSON.stringify({email, password, role: role || 'admin'})})
    const data = await res.json()
    if(res.ok) setUsers(list=>[...list, data].sort((a,b)=>a.email.localeCompare(b.email)))
    else alert('Error: '+data.error)
  }

  async function updateAllowedUser(user, changes){
    const res = await fetch('/api/admin/users/'+user.id, {method:'PUT', headers:{'Content-Type':'application/json'}, body: JSON.stringify(changes)})
    const data = await res.json()
    if(res.ok) setUsers(list=>list.map(item=>item.id===data.id ? data : item))
    else alert('Error: '+data.error)
  }

  async function resetAllowedUserPassword(user){
    const password = await window.reactPrompt('New password for '+user.email+' (minimum 8 characters):')
    if(!password) return
    updateAllowedUser(user, {password})
  }

  async function deleteAllowedUser(user){
    if(!await window.reactConfirm('Remove '+user.email+' from the allowlist?')) return
    const res = await fetch('/api/admin/users/'+user.id, {method:'DELETE'})
    const data = await res.json()
    if(res.ok) setUsers(list=>list.filter(item=>item.id!==user.id))
    else alert('Error: '+data.error)
  }

  async function addClub(){
    const name = await window.reactPrompt('New club name:')
    if(!name) return
    const res = await fetch('/api/clubs', {method:'POST', headers:{'Content-Type':'application/json'}, body: JSON.stringify({name})})
    const c = await res.json()
    setClubs(list=>[...list.filter(x=>x.id!==c.id), c])
  }

  async function deleteClub(id){
    if(!await window.reactConfirm('Delete club?')) return
    await fetch('/api/admin/clubs/'+id, {method:'DELETE'})
    setClubs(list=>list.filter(c=>c.id!==id))
  }

  async function addMember({name, club_id}){
    const res = await fetch('/api/admin/members', {method:'POST', headers:{'Content-Type':'application/json'}, body: JSON.stringify({name, club_id})})
    const m = await res.json()
    if(res.ok) setMembers(list=>[...list, m])
    else alert('Error: '+(m.error || JSON.stringify(m)))
  }

  async function deleteMember(id){
    if(!await window.reactConfirm('Delete member?')) return
    await fetch('/api/admin/members/'+id, {method:'DELETE'})
    setMembers(list=>list.filter(m=>m.id!==id))
  }

  async function addRole(){
    const name = await window.reactPrompt('Role name:')
    if(!name) return
    const points = await window.reactPrompt('Points for this role (number):', '1')
    const res = await fetch('/api/admin/roles', {method:'POST', headers:{'Content-Type':'application/json'}, body: JSON.stringify({name, points})})
    const r = await res.json()
    if(res.ok) setRoles(list=>[...list, r])
    else alert('Error: '+JSON.stringify(r))
  }

  async function editRole(role){
    const name = await window.reactPrompt('Role name:', role.name)
    if(name===null) return
    const points = await window.reactPrompt('Points:', ''+role.points)
    const res = await fetch('/api/admin/roles/'+role.id, {method:'PUT', headers:{'Content-Type':'application/json'}, body: JSON.stringify({name, points})})
    const r = await res.json()
    setRoles(list=>list.map(x=> x.id===r.id? r: x))
  }

  async function deleteRole(id){
    if(!await window.reactConfirm('Delete role?')) return
    await fetch('/api/admin/roles/'+id, {method:'DELETE'})
    setRoles(list=>list.filter(r=>r.id!==id))
  }

  async function deleteReport(id){
    if(!await window.reactConfirm('Delete report? This is permanent.')) return
    const res = await fetch('/api/admin/meetings/'+id, { method: 'DELETE' })
    if(res.ok){ setReports(list=>list.filter(r=>r.id!==id)); alert('Deleted') }
    else { const txt = await res.text(); alert('Error: '+txt) }
  }

  return (
    <section className="admin-dashboard">
      <div className="admin-hero">
        <div><span className="eyebrow">Administration</span><h2>Control center</h2><p>Manage your club, meeting roles, reports, and access from one place.</p></div>
        <span className="admin-shield">{isSuperAdmin ? 'Super Admin' : 'Admin'}</span>
      </div>

      <div className="admin-stats">
        <div><span>Clubs</span><strong>{clubs.length}</strong></div>
        <div><span>Members</span><strong>{members.length}</strong></div>
        <div><span>Roles</span><strong>{roles.length}</strong></div>
        <div><span>Reports</span><strong>{reports.length}</strong></div>
        {isSuperAdmin && <div><span>Approved users</span><strong>{users.filter(user=>user.is_active).length}</strong></div>}
      </div>

      <div className="admin-grid">
        <section className="admin-card">
          <div className="admin-card-heading"><div><span className="admin-icon">◈</span><div><h3>Clubs</h3><p>Organize your participating clubs.</p></div></div><button className="primary" onClick={addClub}>+ Add club</button></div>
          <div className="admin-list">{clubs.map(c=> <div className="admin-list-row" key={c.id}><span className="list-avatar">{c.name[0]?.toUpperCase()}</span><strong>{c.name}</strong><button className="text-button danger" onClick={()=>deleteClub(c.id)}>Delete</button></div>)}{!clubs.length && <p className="empty-copy">No clubs yet.</p>}</div>
        </section>

        <section className="admin-card">
          <div className="admin-card-heading"><div><span className="admin-icon">◎</span><div><h3>Members</h3><p>Maintain the club roster.</p></div></div><button className="primary" onClick={()=>setShowAddMember(true)}>+ Add member</button></div>
          <div className="admin-list">{members.map(m=> <div className="admin-list-row" key={m.id}><span className="list-avatar">{m.name[0]?.toUpperCase()}</span><div><strong>{m.name}</strong><small>{clubs.find(c=>c.id===m.club_id)?.name || 'Not assigned'}</small></div><button className="text-button danger" onClick={()=>deleteMember(m.id)}>Delete</button></div>)}{!members.length && <p className="empty-copy">No members yet.</p>}</div>
        </section>
        {showAddMember && <AddMemberModal clubs={clubs} onClose={()=>setShowAddMember(false)} onSave={addMember} />}

        <section className="admin-card admin-card-wide">
          <div className="admin-card-heading"><div><span className="admin-icon">✦</span><div><h3>Meeting roles</h3><p>Set the points awarded for each role.</p></div></div><button className="primary" onClick={addRole}>+ Add role</button></div>
          <div className="role-table"><div className="role-row role-header"><span>Role</span><span>Points</span><span>Actions</span></div>{roles.map(r => <div className="role-row" key={r.id}><strong>{r.name}</strong><span className="role-points">{r.points} pts</span><span><button className="text-button" onClick={()=>editRole(r)}>Edit</button><button className="text-button danger" onClick={()=>deleteRole(r.id)}>Delete</button></span></div>)}</div>
        </section>

        <section className="admin-card">
          <div className="admin-card-heading"><div><span className="admin-icon">▤</span><div><h3>Reports</h3><p>Manage saved meeting reports.</p></div></div></div>
          <div className="admin-list">{reports.map(r=> <div className="admin-list-row" key={r.id}><div><strong>{r.meeting_no || 'Untitled report'}</strong><small>{r.meeting_date || 'No date'}</small></div><button className="text-button danger" onClick={()=>deleteReport(r.id)}>Delete</button></div>)}{!reports.length && <p className="empty-copy">No saved reports yet.</p>}</div>
        </section>

        {isSuperAdmin && <section className="admin-card access-card">
          <div className="admin-card-heading"><div><span className="admin-icon">⌘</span><div><h3>Access control</h3><p>Only active, allowlisted emails can sign in.</p></div></div><button className="primary" onClick={addAllowedUser}>+ Add user</button></div>
          <div className="admin-list">{users.map(user => <div className="admin-list-row access-row" key={user.id}><span className="list-avatar">{user.email[0]?.toUpperCase()}</span><div><strong>{user.email}</strong><small><span className={user.is_active ? 'status active-status' : 'status'}>{user.is_active ? 'Active' : 'Disabled'}</span> · {user.role.replace('_', ' ')}</small></div><div className="row-actions"><button className="text-button" onClick={()=>updateAllowedUser(user, {is_active: !user.is_active})}>{user.is_active ? 'Disable' : 'Enable'}</button><button className="text-button" onClick={()=>resetAllowedUserPassword(user)}>Reset password</button><button className="text-button danger" onClick={()=>deleteAllowedUser(user)}>Remove</button></div></div>)}</div>
        </section>}
      </div>
    </section>
  )
}

// EditMeetingModal extracted to ./components/EditMeetingModal.js

export default function App(){
  const [tab, setTab] = useState('leaders')
  const [isAdmin, setIsAdmin] = useState(false)
  const [isSuperAdmin, setIsSuperAdmin] = useState(false)
  const [showLogin, setShowLogin] = useState(false)
  const [credentials, setCredentials] = useState({email: '', password: ''})
  const [loginError, setLoginError] = useState('')
  const [editing, setEditing] = useState(null)
  const [pastKey, setPastKey] = useState(0)
  const refreshPast = ()=> setPastKey(k=>k+1)

  useEffect(()=>{
    fetch('/api/auth/status')
      .then(res=>res.ok ? res.json() : {authenticated: false})
      .then(data=>{
        setIsAdmin(Boolean(data.authenticated))
        setIsSuperAdmin(data.role === 'super_admin')
      })
      .catch(()=>{ setIsAdmin(false); setIsSuperAdmin(false) })
  }, [])

  async function login(event){
    event.preventDefault()
    setLoginError('')
    try{
      const res = await fetch('/api/auth/login', {method:'POST', headers:{'Content-Type':'application/json'}, body: JSON.stringify(credentials)})
      const data = await res.json()
      if(!res.ok) throw new Error(data.error || 'Unable to sign in')
      setIsAdmin(true)
      setIsSuperAdmin(data.role === 'super_admin')
      setShowLogin(false)
      setCredentials(current=>({...current, password: ''}))
      setTab('submit')
    }catch(error){
      setLoginError(error.message)
    }
  }

  async function logout(){
    await fetch('/api/auth/logout', {method:'POST'})
    setIsAdmin(false)
    setIsSuperAdmin(false)
    setEditing(null)
    setTab('leaders')
  }

  return (
    <div className="app-shell">
      <header className="site-header">
        <button className="brand" onClick={()=>setTab('leaders')}><span>SR</span> Secretary Report</button>
        {isAdmin ? (
          <div className="admin-session"><span>Admin session</span><button className="logout-button" onClick={logout}>Sign out</button></div>
        ) : <button className="login-button" onClick={()=>setShowLogin(true)}>Admin sign in</button>}
      </header>
      <main className="container">
        <nav className="tabs" aria-label="Main navigation">
          <button className={tab==='leaders' ? 'tab active' : 'tab'} onClick={()=>setTab('leaders')}>Leaderboards</button>
          {isAdmin && <>
            <button className={tab==='submit' ? 'tab active' : 'tab'} onClick={()=>setTab('submit')}>Submit Report</button>
            <button className={tab==='past' ? 'tab active' : 'tab'} onClick={()=>setTab('past')}>Past Reports</button>
            <button className={tab==='admin' ? 'tab active' : 'tab'} onClick={()=>setTab('admin')}>Admin</button>
          </>}
        </nav>
        {showLogin && <form className="login-panel" onSubmit={login}>
          <div><span className="eyebrow">Administrator access</span><h2>Sign in to manage reports</h2><p>Reports, attendees, roles, and settings are only available to administrators.</p></div>
          <label>Email<input type="email" autoComplete="username" value={credentials.email} onChange={e=>setCredentials({...credentials, email:e.target.value})} /></label>
          <label>Password<input type="password" autoComplete="current-password" value={credentials.password} onChange={e=>setCredentials({...credentials, password:e.target.value})} /></label>
          {loginError && <p className="login-error">{loginError}</p>}
          <div className="login-actions"><button type="button" className="secondary" onClick={()=>{setShowLogin(false); setLoginError('')}}>Cancel</button><button className="primary" type="submit">Sign in</button></div>
        </form>}
        <div>
          {tab==='submit' && isAdmin && <SubmitReport />}
          {tab==='past' && isAdmin && <PastReports onEdit={(m)=>setEditing(m)} refreshKey={pastKey} />}
          {tab==='leaders' && <Leaderboards />}
          {tab==='admin' && isAdmin && <Admin isSuperAdmin={isSuperAdmin} />}
        </div>
      </main>
      <ModalHost />
      <EditMeetingModal meeting={editing} onClose={()=>setEditing(null)} onSaved={()=>{ setEditing(null); refreshPast() }} />
    </div>
  )
}

function ModalHost(){
  const [modal, setModal] = useState(null)
  const [inputVal, setInputVal] = useState('')
  useEffect(()=>{
    function handler(e){
      const d = e.detail || {}
      setModal(d)
      setInputVal(d.defaultValue || '')
    }
    window.addEventListener('react-modal-request', handler)
    return ()=> window.removeEventListener('react-modal-request', handler)
  }, [])
  if(!modal) return null
  const close = (result)=>{
    try{ const p = window.__reactModalPromises && window.__reactModalPromises[modal.id]; if(p) p(result); delete window.__reactModalPromises[modal.id] }catch(e){}
    setModal(null)
  }
  return (
    <div style={{position:'fixed',left:0,top:0,right:0,bottom:0,background:'rgba(0,0,0,0.5)',display:'flex',alignItems:'center',justifyContent:'center',zIndex:9999}}>
      <div style={{background:'#fff',padding:20,borderRadius:8,width:'90%',maxWidth:560}}>
        <h3 style={{marginTop:0}}>{modal.type==='confirm'?'Confirm':'Input'}</h3>
        <div style={{marginBottom:12}}>{modal.message}</div>
        {modal.type==='prompt' && <input autoFocus value={inputVal} onChange={e=>setInputVal(e.target.value)} style={{width:'100%',padding:8,marginBottom:12}} />}
        <div style={{textAlign:'right'}}>
          <button className="secondary" onClick={()=>close(modal.type==='confirm'?false:null)} style={{marginRight:8}}>Cancel</button>
          <button className="primary" onClick={()=>close(modal.type==='confirm'?true:(inputVal===undefined?null:inputVal))}>OK</button>
        </div>
      </div>
    </div>
  )
}
